// Persist the "bar labels follow scroll" view preference across reloads. It's a
// single global toggle (not per-site), stored as '1' / '0', DEFAULT ON — unlike
// stickyGroupsPref — because a label that scrolls out of view leaves the bar
// unidentifiable. Guarded like utils/lastSite so a blocked or unavailable
// localStorage (private mode, SSR) silently falls back to the default instead
// of throwing.
const KEY = 'dorca_scheduler_sticky_labels';

export function readStickyLabelsPref(): boolean {
  try { return localStorage.getItem(KEY) !== '0'; } catch { return true; }
}

export function writeStickyLabelsPref(value: boolean): void {
  try { localStorage.setItem(KEY, value ? '1' : '0'); } catch { /* ignore */ }
}
